// 移动端子菜单打开时，主菜单背景降低透明度
document.addEventListener('DOMContentLoaded', () => {
  const drawer = document.querySelector('.menu-drawer');
  if (!drawer) return;

  const overlay = document.createElement('div');
  overlay.id = 'menu-drawer-overlay';
  overlay.style.cssText = `
    position: absolute;
    inset: 0;
    background-image: var(--graffiti-bg);
    background-size: cover;
    background-position: center;
    background-color: #111;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
    z-index: 0;
  `;
  drawer.style.position = 'relative';
  drawer.prepend(overlay);

  const nav = drawer.querySelector('.menu-drawer__navigation');
  if (nav) nav.style.position = 'relative', nav.style.zIndex = '1';

  const observer = new MutationObserver(() => {
    const submenu = drawer.querySelector('.menu-drawer__submenu');
    const submenuOpen = submenu && submenu.querySelector('details[open]');
    overlay.style.opacity = submenuOpen ? '0.6' : '0';
  });

  observer.observe(drawer, { attributes: true, subtree: true, childList: true });
});

